import React from 'react';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import { useTranslation } from 'react-i18next';
import { azure, glass, line } from '../theme';

const LANGS = [
  { code: 'en', label: 'EN' },
  { code: 'ar', label: 'عربي' },
];

// Segmented EN | عربي control with an active pill.
export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const current = i18n.language === 'ar' ? 'ar' : 'en';

  return (
    <Box
      role="group"
      aria-label="Language"
      sx={{
        display: 'inline-flex',
        p: 0.4,
        borderRadius: 999,
        border: `1px solid ${line}`,
        bgcolor: glass,
      }}
    >
      {LANGS.map(({ code, label }) => {
        const selected = current === code;
        return (
          <ButtonBase
            key={code}
            onClick={() => i18n.changeLanguage(code)}
            aria-pressed={selected}
            sx={{
              px: 1.5,
              py: 0.45,
              borderRadius: 999,
              fontSize: '0.8rem',
              fontWeight: 700,
              fontFamily: code === 'ar' ? '"IBM Plex Sans Arabic","Segoe UI",sans-serif' : 'inherit',
              color: selected ? '#04121F' : 'text.secondary',
              bgcolor: selected ? azure[300] : 'transparent',
              transition: 'all .2s ease',
              '&:hover': { color: selected ? '#04121F' : 'text.primary' },
            }}
          >
            {label}
          </ButtonBase>
        );
      })}
    </Box>
  );
}
